import { CameraswitchOutlinedIcon, PhotoCameraFrontIcon } from 'tuui';
import { MOTION_PARAM_CATEGORIES, MOTION_PARAM_OPTIONS } from '../consts/motionParamsConsts';
import { MotionParamDropdown } from './MotionParamDropdown';
import styles from './motionParamsDropdownsContainer.module.scss';

export const MotionParamsDropdownContainer = () => {
    return (
        <div className={styles.container}>
            <MotionParamDropdown
                category={MOTION_PARAM_CATEGORIES.SUBJECT_MOVEMENT}
                id="subject-movement-dropdown"
                options={MOTION_PARAM_OPTIONS[MOTION_PARAM_CATEGORIES.SUBJECT_MOVEMENT]}
                dropdownMessageId="creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.placeholder"
                dropdownMessage="Subject Movement"
                icon={PhotoCameraFrontIcon}
                ariaLabel="subject-movement-dropdown"
            />

            <MotionParamDropdown
                category={MOTION_PARAM_CATEGORIES.CAMERA_MOVEMENT}
                id="camera-movement-dropdown"
                options={MOTION_PARAM_OPTIONS[MOTION_PARAM_CATEGORIES.CAMERA_MOVEMENT]}
                dropdownMessageId="creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.placeholder"
                dropdownMessage="Camera Movement"
                icon={CameraswitchOutlinedIcon}
                ariaLabel="camera-movement-dropdown"
            />
        </div>
    );
};
